<template>
  <Modal :id="'cmp-add-group'" @cancelled="onCancelClick">
    <template slot="header">
      <v-layout row wrap mx-1>{{$t('add')}} {{$t('submenu_GROUPS')}}</v-layout>
    </template>
    <template slot="body">
      <SearchList
        :id="'unrelated_groups'"
        ref="searchList"
        :items="unrelated_groups"
        :keyProperty="'group_id'"
        :label="'group_name'"
        @selected="onGroupSelected"
        @searched="onGroupSearched"
        @cancelNewItem="onCancelNewItem"
        @newAdded="onNewAddedGroup"
      />
      <!-- <v-layout row wrap py-3 class="elevation-2">
        <v-flex md3>
          <TextField
            :id="'last_name'"
            v-bind="textFieldConfig"
            v-model="newGroupName"
            :placeholder="$t('group_name')"
          />
        </v-flex>
        <v-flex md3>
          <button class="dt-button v1 s3" @click="onAddGroupClick">{{$t('add_new_group')}}</button>
        </v-flex>
      </v-layout>
      <v-layout row wrap my-3 mx-1>
        <v-flex md4>
          <InputField
            :value="searchString"
            :placeholder="'Search'"
            :config="{
                    borderStyle: 'around'
                }"
            @keyup="onSearchInputKeyup"
          ></InputField>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-start px-1 py-3 class="elevation-2">
        <v-flex md2 v-for="unrelated_group of unrelated_groups" :key="unrelated_group.value">
          <v-layout my-1 row wrap>
            <v-flex md3>
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="unrelated_group.group_id"
                  :id="unrelated_group.group_id"
                  :checked="selected_groups.has(unrelated_group.group_id)"
                  @click="e => ongroupSelected(e, unrelated_group.group_id)"
                />
                <div
                  class="checkmark"
                  :style="{
                        'backgroundColor': unrelated_group.color,
                        'borderColor': unrelated_group.borderColor
                    }"
                ></div>
              </div>
            </v-flex>
            <v-flex md9>
              <div
                class="month-text txtov"
                :title="unrelated_group.text"
              >{{unrelated_group.group_name}}</div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">{{$t('cancel')}}</button>
      <button
        class="dt-button v1 with-ico s6"
        @click="createNewGroup"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{$t('add_new_group')}}
        </div>
      </button>
      <button class="dt-button v1 s6" @click="onOKClick">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import { GroupService } from "./groups.service";
import { configValidator } from "../modal/validator";
import { setRandColor, addRemoveSet } from "../../utility";
// import { Subject } from "rxjs";
// import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import SearchList from "@dtplugins/search-list/search-list";
import { createNewSearchListItemFromComponent } from "../search-list";

import Modal from "../modal/modal";

import { getGroupConfig } from "./config";

export default {
  components: {
    Modal,
    SearchList
  },
  props: {},
  data: function() {
    return {
      textAreaConfig: {
        height: 120,
        showEditIconOnHover: false,
        box: true,
        textarea: true,
        showValidationIcons: false
      },
      unrelated_groups: [],
      selected_groups: new Set(),
      config: null,
      // searchString: "",
      newGroupName: "",
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true
      },

      // searchSubject$: new Subject(),
      external_table: "groups"
    };
  },
  mixins: [configValidator({})],
  mounted: function() {
    GroupService.findUnrelatedGroups({
      contact_id: this.contact_id
    }).then(res => {
      console.log(res);
      this.setUnrelatedGroups(res.data.unrelated_groups);
    });

    this.config = getGroupConfig(this.external_table);

    // this.$subscribeTo(
    //   this.searchSubject$.asObservable().pipe(
    //     distinctUntilChanged(),
    //     debounceTime(400)
    //   ),
    //   searchString => {
    //     GroupService.searchUnrelatedGroups({
    //       search: searchString,
    //       contact_id: this.contact_id
    //     }).then(res => {
    //       this.setUnrelatedGroups(res.data.unrelated_groups);
    //     });
    //   }
    // );
  },
  computed: {
    reqObject: function() {
      return {
        contact_id: this.contact_id
      };
    },
    contact_id: function() {
      return this.$route.query.contact_id;
    }
  },
  methods: {
    onGroupSelected: async function(selected_groups) {
      this.selected_groups = selected_groups;
    },
    onGroupSearched: function(searchString) {
      GroupService.searchUnrelatedGroups({
          search: searchString,
          contact_id: this.contact_id
        }).then(res => {
          this.setUnrelatedGroups(res.data.unrelated_groups);
        });
    },
    onCancelNewItem: function() {
      this.unrelated_groups = this.unrelated_groups.filter(group => group.group_id !== 'NEW_ITEM_TEMP');
    },
    onNewAddedGroup: async function(groupName) {
      // console.log(groupName);
      const unrelated_groups = await GroupService.insertNewGroup({
        group_name: groupName,
        contact_id: this.contact_id
      });
     this.unrelated_groups = unrelated_groups.data.unrelated_groups;
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onOKClick: async function() {
      const group_ids = Array.from(this.selected_groups).join(",");
      const checked_group_ids = Array.from(this.selected_groups)
        .map(e => 1)
        .join(",");

      const selected_groups = await GroupService.insertGroupRelation({
        contact_id: this.contact_id,
        group_ids,
        checked_group_ids
      });

      this.$emit("done", {
        action: this.config.action,
        payload: selected_groups
      });
    },
    onSearchInputKeyup: function(event) {
      // this.searchString = event.target.value;
      // this.searchSubject$.next(this.searchString);
    },
    setUnrelatedGroups: function(groups) {
      this.unrelated_groups = setRandColor(groups, true);
    },
    onAddGroupClick: async function() {
      const unrelated_groups = await GroupService.insertNewGroup({
        group_name: this.newGroupName,
        contact_id: this.contact_id
      });
      this.setUnrelatedGroups(unrelated_groups.data.unrelated_groups);
      this.newGroupName = "";
    },
    createNewGroup: function(group) {
      createNewSearchListItemFromComponent(this, 'unrelated_groups', 'group_id', 'searchList');
    }

    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-add-group {
}
</style>